import { ReactNode, createContext, useContext, useState } from "react";

export type PdfMeta = {
  url?: string | null;
  blob?: Blob | null;
  pdfDocument?: any;
  fileName?: string;
  isLoading?: boolean;
  debugInformation?: any;
};

interface PDFGenerationV3ContextType {
  pdfMeta?: PdfMeta;
  setPdfMeta: React.Dispatch<React.SetStateAction<PdfMeta | undefined>>;
}

const PDFGenerationV3Context = createContext<PDFGenerationV3ContextType | null>(
  null
);

interface PDFGenerationV3ProviderProps {
  children: ReactNode;
}

export const PDFGenerationV3Provider = ({
  children,
}: PDFGenerationV3ProviderProps) => {
  const [pdfMeta, setPdfMeta] = useState<PdfMeta | undefined>();

  return (
    <PDFGenerationV3Context.Provider
      value={{
        pdfMeta,
        setPdfMeta,
      }}
    >
      {children}
    </PDFGenerationV3Context.Provider>
  );
};

export const usePDFGenerationV3 = () => {
  const context = useContext(PDFGenerationV3Context);
  if (!context) {
    throw new Error(
      "usePDFGenerationV3 must be used within a PDFGenerationV3Provider"
    );
  }
  return context;
};
